module.exports = __webpack_public_path__ + "img/angi-norbi.5a6b258a.jpg";